import React, { useRef, useState } from 'react';
import { Camera, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError, pictureUrl } from '../../lib/api';

export const AvatarUploader = ({ user, onUpdated }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      toast.error('Biletet kan maks vere 5 MB');
      return;
    }
    const form = new FormData();
    form.append('file', file);
    setUploading(true);
    try {
      const { data } = await api.post('/users/me/avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      onUpdated(data);
      toast.success('Profilbiletet er oppdatert');
    } catch (err) {
      toast.error(formatApiError(err, 'Opplasting feila'));
    } finally {
      setUploading(false);
    }
  };

  const src = pictureUrl(user.picture);

  return (
    <div className="flex flex-col items-center gap-4" data-testid="avatar-uploader">
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        data-testid="avatar-change-button"
        className="group relative w-36 h-36 md:w-44 md:h-44 rounded-full overflow-hidden border-4 border-[#ff2e2e] shadow-2xl shadow-[#ff2e2e]/30 bg-[#1a1020]"
        aria-label="Endre profilbilete"
      >
        {src ? (
          <img src={src} alt={user.name} data-testid="avatar-image" className="w-full h-full object-cover" />
        ) : (
          <div data-testid="avatar-initial" className="w-full h-full flex items-center justify-center text-6xl font-bold text-[#ff2e2e]">
            {user.name?.[0]?.toUpperCase() || 'U'}
          </div>
        )}
        <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          {uploading ? <Loader2 size={28} className="animate-spin text-white" /> : <Camera size={28} className="text-white" />}
          <span className="text-white text-xs font-bold uppercase tracking-wider">{uploading ? 'Lastar opp' : 'Endre'}</span>
        </div>
      </button>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={onFile} className="hidden" data-testid="avatar-file-input" />
      <p className="text-white/40 text-xs">JPG, PNG eller WEBP · maks 5 MB</p>
    </div>
  );
};
